import type { Music24PlanTier } from 'fym-shared/src/music24/music24Plans';

/** Where the workspace is in the trial: the texts of the pill, the Home card and the takeover follow it. */
export type UpsellTrialPhase = 'running' | 'lastDay' | 'free';

/**
 * The phase of a plan with the watermark. The last day is `trialDaysRemaining <= 1`, the rule of
 * the takeover (`upsellAutoModal`) and of the sidebar pill.
 */
export function upsellTrialPhase(plan: Music24PlanTier, trialDaysRemaining: number | null): UpsellTrialPhase {
  if (plan !== 'trial' || trialDaysRemaining === null) {
    return 'free';
  }
  return trialDaysRemaining <= 1 ? 'lastDay' : 'running';
}
